<template>
<div class="targets-main" v-if="targetIds"  v-loading="loading" :element-loading-text="loadingText">
    <div style="font-size:12px;flex:1 1">
      <div style="margin:10px 0px">
        <el-pagination background layout="prev, pager, next" :current-page="page" :page-size="$store.state.itemsPerPage" :total="targetIds.length" @current-change="page=$event"></el-pagination>
      </div>

      <!-- results table -->
      <div class="shaded-box" v-for="(id, i) in sortedTargetIds" :key="i">
        <div class="padded-box">
            <div style="margin:5px 0px">
              <span style="font-size:20px;font-weight:550">{{targets[id].pref_name}}</span>
            </div>

            <div class="target-type">
              <div><b>ID</b>:</div>
              <div>
                <span><a target="_blank" :href="targetLink(targets[id].database, id)" style="margin:0px 10px 0px 0px">{{id}} (CHEMBL)</a></span>
                <span v-for="(acc, accid, iacc) in targets[id].accession" :key="iacc" v-text="`${accid} (${acc.db})`" style="margin:0px 10px"></span>
              </div>
            </div>

            <div class="target-type">
              <div><b>Score</b>:</div>
              <div style="width:80px"><el-progress :stroke-width="5" :color="'#46c8c8'" :show-text="false" :percentage="targetScores[id]*100"></el-progress></div>
              <div>{{toFixed(targetScores[id], 2)}}</div>
            </div>

            <div class="target-type">
              <div><b>Type</b>:</div>
              <div>{{targets[id].type}}</div>
            </div>

            <div class="target-type">
              <div><b>Species</b>:</div>
              <div>{{targets[id].organism}}</div>
            </div>

            <el-row v-if="targets[id].assays.length>0" class="group-button-container">
              <div>
                <b>Associated Compounds ({{$store.getters.targetCompounds[id].length}})</b>:
              </div>
              <div>
                <button-group :data="targetCompounds[id].map(compoundid => { let compound = compounds[compoundid]; return { name: `${compoundid} (${toFixed(compound.score, 2)})`, link: compLink(compound.db, compoundid) } })"></button-group>
              </div>
            </el-row>

            <el-row v-if="targets[id].functions.length>0" class="group-button-container">
              <div><b>Functions</b>:</div>
              <div>
                <button-group :data="targets[id].functions.map(functionid => { let func = functions[functionid]; return { name: func.name, link: `https://www.ebi.ac.uk/QuickGO/GTerm?id=${func.id}` } })"></button-group>
              </div>
            </el-row>

            <el-row v-if="targets[id].processes.length>0" class="group-button-container">
              <div>
                <b>Processes</b>:
              </div>
              <div>
                <button-group :data="targets[id].processes.map(processid => { let proc = processes[processid]; return { name: proc.name, link: `https://www.ebi.ac.uk/QuickGO/GTerm?id=${proc.id}` } })"></button-group>
              </div>
            </el-row>
          </div>

          <div class="padded-box target-card-bottom">
            <div>
              <a @click="idToShow=id;assayVisible=true">Assays</a>
              <el-dialog :visible.sync="assayVisible" v-if="assayVisible && idToShow">
                <div style="width:800px;padding:15px;font-size:11px">
                  <div style="display:flex;flex-direction:row;">
                    <div style="flex:0 0 150px;margin-left:40px;font-weight:550">
                      <div class="assay-row">Assay ID</div>
                      <div class="assay-row">Ligand</div>
                      <div class="assay-row">Ligand Similarity</div>
                      <div class="assay-row">Activity</div>
                      <div class="assay-row">Activity Type</div>
                    </div>

                    <div style="display:flex;flex-direction:row;flex:1;overflow-x:auto;padding:0px 5px">
                      <div v-for="(assayid, j) in targets[idToShow].assays" :key="j" style="flex:0 0 150px">
                        <div class="assay-row"><a target="_blank" :href="assayLink(compounds[assays[assayid].compound].database, assayid)">{{assayid}}</a>&nbsp;</div>
                        <div class="assay-row"><a target="_blank" :href="compLink(compounds[assays[assayid].compound].database, assays[assayid].compound)">{{assays[assayid].compound}}</a>&nbsp;</div>
                        <div class="assay-row">{{compounds[assays[assayid].compound].score}}&nbsp;</div>
                        <div class="assay-row">{{toFixed(assays[assayid].act_value, 2)}} {{assays[assayid].act_units}}&nbsp;</div>
                        <div class="assay-row">{{assays[assayid].act_type}}&nbsp;</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-dialog>
            </div>

            <div>
              <a @click="seqToShow=targets[id].seq;sequenceVisible=true">Sequence</a>
              <el-dialog :visible.sync="sequenceVisible"><div class="wrap-text" v-text="seqToShow"></div></el-dialog>
            </div>
          </div>
      </div>

      <div style="margin:10px 0px">
        <el-pagination background layout="prev, pager, next" :page-size="$store.state.itemsPerPage" :current-page="page" :total="targetIds.length" @current-change="page=$event"></el-pagination>
      </div>
    </div>

    <div style="flex:0 0 300px;margin-left:15px;margin-top:20px;">
      <div style="position:sticky;top:10px">
        <!-- <div class="results-menu-filters" @click="filtersVisible=true"><i class="el-icon-edit-outline"></i> Filters</div> -->

        <!-- Number of results -->
        <div style="margin-bottom:20px"><b v-text="Object.keys(targets).length"></b> Targets</div>

        <!-- Sort -->
        <div class="results-menu-sort">
          <div @click="sortMenuVisible=true"><i class="el-icon-sort"></i> Sort</div>

          <!-- Sort Menu -->
          <div class="popup-menu" v-if="sortMenuVisible">
            <div class="popup-menu-head">
              <div class="popup-menu-title">CHOOSE SORT OPTIONS</div>
              <div class="popup-menu-close" @click="sortMenuVisible=false"><i class="el-icon-close"></i></div>
            </div>
            <div class="popup-menu-body">
              <div class="popup-menu-item" @click="sortMenuVisible=false;sortTargets('score')">
                <span>Name</span>
              </div>
              <div class="popup-menu-item" @click="sortMenuVisible=false;sortTargets('type')">
                <span>Type</span>
              </div>
              <div class="popup-menu-item" @click="sortMenuVisible=false;sortTargets('organism')">
                <span>Species</span>
              </div>
              <div class="popup-menu-item" @click="sortMenuVisible=false;sortTargets('score')">
                <span>Score</span>
              </div>
              <div class="popup-menu-item" @click="sortMenuVisible=false;sortTargets('ncompounds')">
                <span>Number of Associated Compounds</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Download -->
        <div class="results-menu-download">
          <div class="popup-menu-button" @click="downloadMenuVisible=true"><i class="el-icon-download"></i> Download</div>

          <!-- Download Menu -->
          <div class="popup-menu" v-if="downloadMenuVisible">
            <div class="popup-menu-head">
              <div class="popup-menu-title">DOWNLOAD</div>
              <div class="popup-menu-close" @click="downloadMenuVisible=false"><i class="el-icon-close"></i></div>
            </div>
            <div class="popup-menu-body">
              <!-- <div class="popup-menu-item" @click="savePdf();downloadMenuVisible=false;">
                Report (pdf)
              </div> -->
              <div class="popup-menu-item" @click="saveTargets();downloadMenuVisible=false">
                Targets of the Current Query Compound (csv)
              </div>
              <div class="popup-menu-item" @click="saveAllTargets();downloadMenuVisible=false">
                Targets of All Query Compounds (csv)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

</div>
</template>

<script>
import Chart from 'chart.js'
import ButtonGroup from './ButtonGroup.vue'
import { bus } from '../bus.js'
import utils from '../utils.js'
import Vuex from 'vuex'
import makeTaskStore from '../store/task-store.js'

const mapGetters = Vuex.mapGetters

function formatCSVValue(value) {
  if (typeof value === 'string' && value.includes(',')) {
    return `"${value.replace(/"/g, '""')}"`
  } else {
    return `${value}`;
  }
}

export default {
  name: 'Targets',

  data () {
    return {
      sortMenuVisible: false,
      downloadMenuVisible: false,

      idToShow: '',
      assayVisible: false,

      sortBy: 'score',
      sortDirection: 1,

      page: 1,

      sequenceVisible: false,
      seqToShow: '',

      loading: false,
      loadingText: ''
    }
  },

  components: {
    ButtonGroup
  },

  computed: {
    ...mapGetters([
      'assays',
      'targets',
      'compounds',
      'processes',
      'functions',
      'targetCompounds',
      'targetIds',
      'targetScores'
    ]),

    sortedTargetIds () {
      let n = this.$store.state.itemsPerPage
      let targetCompounds = this.$store.getters.targetCompounds
      let ls = [...this.targetIds]
      if (this.sortBy === 'score') {
        ls.sort((a, b) => (this.targetScores[b] - this.targetScores[a]) * this.sortDirection)
      } else if (this.sortBy === 'name') {
        ls.sort((a, b) => this.safeLocaleCompare(this.$store.getters.targets[b].pref_name, this.$store.getters.targets[a].pref_name) * this.sortDirection)
      } else if (this.sortBy === 'type') {
        ls.sort((a, b) => this.safeLocaleCompare(this.$store.getters.targets[b].type, this.$store.getters.targets[a].type) * this.sortDirection)
      } else if (this.sortBy === 'organism') {
        ls.sort((a, b) => this.safeLocaleCompare(this.$store.getters.targets[b].organism, this.$store.getters.targets[a].organism) * this.sortDirection)
      } else if (this.sortBy === 'ncompounds') {
        ls.sort((a, b) => (targetCompounds[b].length - targetCompounds[a].length) * this.sortDirection)
      }
      return ls.slice((this.page - 1) * n, this.page * n)
    },

    ncompounds () {
      let smi = this.$store.getters.par.compound
      if (smi) {
        return smi.split('\n').filter(line => line.trim() !== '').length
      } else {
        return 0
      }
    }
  },

  methods: {
    ...utils.mapUtils([
      'targetLink',
      'compLink',
      'smilesLink',
      'assayLink',
      'databaseLink',
      'toFixed',
      'safeLocaleCompare',
      'saveCsv',
      'download'
    ]),

    sortTargets (str) {
      this.sortBy = str
      this.sortDirection *= -1
    },
    
    targetLines (store, icompound) {
      let content = ''
      let assays = this.assays
      // console.log(assays)
      for (let targetid in store.getters.targets) {
        let target = store.getters.targets[targetid]
        let targetname = store.getters.targets[targetid].pref_name
        let targetscore = store.getters.targetScores[targetid]
        let maxCompoundScore = 0
        let mostSimilarCompoundId = -1
        for (let compoundid of store.getters.targetCompounds[targetid]) {
          let compound = store.getters.compounds[compoundid]
          if (maxCompoundScore <= compound.score) {
            maxCompoundScore = compound.score
            mostSimilarCompoundId = compoundid
          }
        }
        let mostSimilarCompound = store.getters.compounds[mostSimilarCompoundId]
        let smiles = mostSimilarCompound.smiles
        let fp2score = mostSimilarCompound.fp2score
        let pharmscore = mostSimilarCompound.pharmscore

        let act_type = ''
        let act_value = ''
        if (target.assays.length>0) {
          let assay_id = target.assays[0]
          if (assay_id in assays) {
            let assay = assays[assay_id]
            act_type = assay.act_type
            act_value = assay.act_value
            // content += `${parseInt(icompound) + 1},${targetid},${targetname},${Object.keys(target.accession).join(' ')},${target.seq},${targetscore},${mostSimilarCompoundId},${smiles},${fp2score},${pharmscore},${assay.act_value},${assay.act_type}\n`
          } else {
            console.log('Note Found')
            console.log(assay_id)
          }
        }
        let lineList = [parseInt(icompound) + 1, targetid, targetname, Object.keys(target.accession).join(' '), target.seq, targetscore, mostSimilarCompoundId, smiles, fp2score, pharmscore, act_value, act_type]
        content += lineList.map(formatCSVValue).join(',')
        content += '\n'
        // content += `${parseInt(icompound) + 1},${targetid},${targetname},${Object.keys(target.accession).join(' ')},${target.seq},${targetscore},${mostSimilarCompoundId},${smiles},${fp2score},${pharmscore},${act_value},${act_type}\n`
      }
      return content
    },

    saveTargets () {
      let content = 'No. Query Compound,Target,Name,UniProt ID,Target Sequence,Score,Most Similar Compound,Compounds SMILES,Compound FP2 Similarity,Compound Pharmacophore Similarity,Assay Value,Assay Type\n'
      content += this.targetLines(this.$store, this.$store.state.route.params.icompound)
      this.download(content, `Drift-${this.$store.state.route.params.id}-${this.$store.state.route.params.icompound}-targets.csv`)
    },

    async saveAllTargets () {
      this.loading = true
      let store = new Vuex.Store(makeTaskStore())
      let r = {}
      for (let k of ['minimalCompoundSimilarity', 'hideNullCompounds', 'hideOwnTargets', 'targetTypes', 'targetSpecies', 'assayRange']) {
        r[k] = this.$store.state[k]
      }
      store.commit('set', r)

      let taskid = this.$store.state.route.params.id
      let content = 'No. Query Compound,Target,Name,UniProt ID,Target Sequence,Score,Most Similar Compound,Compounds SMILES,Compound FP2 Similarity,Compound Pharmacophore Similarity,Assay Value,Assay Type\n'
      for (let icompound = 0; icompound < this.ncompounds; icompound++) {
        this.loadingText = `Downloading Targets of Compound ${icompound + 1}`
        await store.dispatch('fetchTask', {taskid, icompound})
        content += this.targetLines(store, icompound)
      }
      this.download(content, `Drift-${this.$store.state.route.params.id}-targets.csv`)
      this.loading = false
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.targets-main {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
}

.summary {
  text-align: center;
}

.summary-row-label {
  color: #85929e;
  font-weight: bold;
  font-size: 30px;
}

.target-row {
  /*
  border: 1px solid lighten($font-grey, 50%);
  */
  border-radius: 4px;
  margin: 20px 0px;
}

.target-card-head {
  /*
  border-bottom: 1px solid lighten($font-grey, 50%);
  */
  height: 30px;
  line-height: 30px;
  padding: 5px 5px 5px 20px;
  font-weight: 600;
}

.target-card-body {
  padding: 20px;
}

.target-id {
  margin-bottom: 10px;
}

.target-name {
  margin-bottom: 10px;
}

.target-type {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.target-type >div {
  margin-right: 10px;
}

.target-organism {
  margin-bottom: 10px;
}

.target-assays {
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 20px;
}

.target-assays-left {
}

.target-assays-right {
  font-size: 14px;
}

.target-assays-right-head {
  font-weight: 600;
}

.target-assay {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.target-assay-ligand {
  width: 200px;
  min-width: 200px;
}

.target-assay-similarity {
  width: 200px;
  min-width: 200px;
}

.target-assay-activity {
  width: 200px;
  min-width: 200px;
}

.target-assay-activity-type {
  width: 200px;
  min-width: 200px;
}

.target-assay-id {
  width: 200px;
  min-width: 200px;
}

.assay-row {
  height: 30px;
  line-height: 30px;
  overflow: hidden;
}

.target-card-bottom {
  border-top:1px solid #eeeeee;
  display:flex;
  flex-direction:row;
}

.target-card-bottom >div {
  margin: 0px 10px;
}

</style>
